import isObject from './isObject';

export default function isKeyInObject<T>(key: string, obj: T): boolean {
  return isObject(obj) && key in obj;
}
